import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `text-meta` is a font size of the design tokens (13px). Without this, tailwind-merge would take it for a text colour and drop it
// next to `text-muted-foreground`.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["meta"] }] } },
});

/** Joins class names and lets the last Tailwind class win over an earlier one that sets the same property. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
